import React, { useState, useEffect } from 'react';
import { Col, NavLink, Form, FormGroup, Input, Button, Nav, NavItem } from 'reactstrap';
import { connect } from 'react-redux';
import { DisplayPayBtnText, RenderForm, GoBack,DisplayConvFee } from 'components/Common';
import GlobalLoaderModal from "components/FDModal/global-loader";
import {
    callCardMetaDataAPI,callSetPayment
  } from "actions/payment";
  
function GrabPayWidget(props){
    const { t } = props;
    
    const [cardMetaData,setCardMetaData]= useState({});
    const [selectedPayment,setPayment] = useState(null);
    const [loader,setLoader] = useState({
        loading:false,
        buttonDisable:false
    });
    const [displayError,setError] = useState({
        error:false,
        errorCode:null,
        errorMessage:"",
    });
    const handleChange = async (value) => {
        
          if(value && value != ""){
            setLoader({
                loading:true,
                buttonDisable:true
            });
            const {
                data: { response }
              } = await callCardMetaDataAPI("GRABPAY");
              setLoader({
                loading:false,
                buttonDisable:false
            });
              if(response && response.convFee){
                setCardMetaData(response);
              }
                setPayment(value);
            }else{
                setCardMetaData({});
                setPayment(null);
            }
    }

    const handleGrabPay = async(e) => {
        if(e){
            e.preventDefault();
        }
        setLoader({
            loading:true,
            buttonDisable:true
        });
        props.callSetPayment('GP',{},props.txnKey, props.txnIv).then((resp)=>{
            const {errorCode,errorMessage,grabPayWebUrl}    = resp.payload.data;
            if(errorCode){
                setError({
                    error:true,
                    errorCode,
                    errorMessage,
                });
                setLoader({
                    loading:false,
                    buttonDisable:false
                });
            }else if(grabPayWebUrl){
                
                window.location = resp.payload.data.grabPayWebUrl;
                // setLoader({
                //     loading:false,
                //     buttonDisable:false
                // });
            }
            
           // window.location = resp.payload.data.grabPayWebUrl;
        })
        return false;
    }

    useEffect( async () => {
        // console.log("txnKey",props.txnKey);
        // console.log("Props",props);
        // console.log("PROPS INTEGRATIONTYPE",props.globalConfig.mConfig.mPaymentModes);
        const paymentMethods = props.globalConfig.mConfig.mPaymentModes
        if(props.integrationType === "MERCHANT_PAYMENT_MODE_INTEGRATION"  
        && paymentMethods.length===1 
        && paymentMethods[0] === "GRABPAY"){
           await handleChange("grabPay");
           handleGrabPay(); 
        }
    }, []);

    return(
        <>
			<Col xs="12" className="minHeight490">
				<div className="card-details-panel d-flex justify-content-center">
					<Form>
						<FormGroup className="custom-dd">
							<Input type="select" name="select"  onChange={(e) => handleChange(e.currentTarget.value)}>
								<option value=''>-- Select option --</option>
								<option value="grabPay" >GrabPay</option>
							</Input>
						</FormGroup>

						<p className="text-14 text-center mb-4">({t('click_on_pay_note')})</p>
                        <div className="text-left">
                            <DisplayConvFee cardMetaData={cardMetaData} t={t}/>
                        </div>
                        <Button
                            type="submit"
                            disabled={!selectedPayment || loader.buttonDisable || !props.termsStatus }
                            onClick={handleGrabPay}
                            className="btn mt-5"
                        >
                            <DisplayPayBtnText
                            labelName="Pay"
                            cardMetaData={cardMetaData}
                            transactionDetails={props.transactionDetails}
                            t={props.t}
                            />
                        </Button>
                        { displayError.error && <span className='error'>{displayError.errorMessage}</span>} 
						<div className="go-back-site text-center">
							<GoBack t={t} />
						</div>
					</Form>
				</div>
			</Col>
            {loader.loading && <GlobalLoaderModal></GlobalLoaderModal>}
            
			{/* { this.state.loader &&  <GlobalLoaderModal transaction={true} /> }
			<RenderForm className='hidden' nbRespURL={this.state.nbRespURL} formName="NB" razorPayRespData={this.state.razorPayRespData} /> */}
			</>
    )
}

const mapStateToProps = state => {
    // defaultSelectedPayment
    // console.log("STATE.FDData",state.fdData.defaultSelectedPayment)
    const { transactionDetails, txnKey, txnIv ,SessionToken,termsStatus,paymentMethodType,integrationType,globalConfig } = state.fdData;
    let returnProps = { transactionDetails, txnKey, txnIv , SessionToken,termsStatus,paymentMethodType,integrationType,globalConfig };
    return { ...returnProps };
  };

export default connect(mapStateToProps, { callSetPayment })(GrabPayWidget);